// AJAX filtering/sorting for the search page. Submits the filter form and swaps the
// rendered sidebar + results in place, without a full page reload.
export const searchFilter = (() => {
    const form = document.querySelector("[data-search-form]");

    // Clear (×) button in the search hero, present on the page regardless of the filter form.
    const clearBtn = document.querySelector("[data-search-clear]");
    const heroInput = document.getElementById("search-input");
    if (clearBtn && heroInput) {
        clearBtn.addEventListener("click", function () {
            heroInput.value = "";
            heroInput.focus();
            clearBtn.classList.add("is-hidden");
        });
        heroInput.addEventListener("input", function () {
            clearBtn.classList.toggle("is-hidden", heroInput.value.length === 0);
        });
    }

    if (!form) return;

    const container = document.getElementById("searchFilterResults");
    const action = form.getAttribute("action");

    // Mobile filter panel open/closed state. Kept in JS so it survives the AJAX
    // re-render (which replaces the filter markup with a collapsed default).
    let filtersOpen = false;
    // Section ids the user collapsed (desktop chevrons). Also kept in JS so the
    // collapsed state survives the re-render, which resets sections to expanded.
    const collapsedSections = new Set();
    function applyFilterState() {
        const aside = container && container.querySelector("[data-search-filter]");
        if (!aside) return;
        aside.classList.toggle("is-open", filtersOpen);
        const toggle = aside.querySelector("[data-filter-toggle]");
        if (toggle) {
            toggle.setAttribute("aria-expanded", String(filtersOpen));
            const label = filtersOpen ? toggle.dataset.labelOpen : toggle.dataset.labelClosed;
            if (label) toggle.textContent = label;
        }
        aside.querySelectorAll("[data-section-toggle]").forEach(function (btn) {
            const id = btn.getAttribute("aria-controls");
            const collapsed = collapsedSections.has(id);
            btn.setAttribute("aria-expanded", String(!collapsed));
            const body = document.getElementById(id);
            if (body) body.hidden = collapsed;
        });
    }

    function buildQueryString(resetPage) {
        const formData = new FormData(form);
        if (resetPage) {
            formData.set("pageNo", "1");
        }
        const params = new URLSearchParams();
        for (const [key, value] of formData.entries()) {
            params.append(key, value);
        }
        return params.toString();
    }

    async function submit(resetPage) {
        if (!container) return;
        container.classList.add("is-loading");
        try {
            const response = await fetch(action + "?" + buildQueryString(resetPage), {
                headers: { "X-Requested-With": "XMLHttpRequest" }
            });
            if (response.ok) {
                // Fetch the full page and swap in just the results fragment (mirrors newsloader.js).
                const html = await response.text();
                const doc = new DOMParser().parseFromString(html, "text/html");
                const fresh = doc.getElementById("searchFilterResults");
                if (fresh) {
                    container.innerHTML = fresh.innerHTML;
                    applyFilterState();
                }
            }
        } catch (e) {
            // Leave the current results in place on failure.
        } finally {
            container.classList.remove("is-loading");
        }
    }

    // Changing sort or content-type resets to the first page.
    form.addEventListener("change", function (e) {
        if (e.target.matches("input[name='sort'], input[name='selectedCategories']")) {
            submit(true);
        }
    });

    form.addEventListener("click", function (e) {
        // Mobile: toggle the filter panel (button is type="button", so no submit).
        if (e.target.closest("[data-filter-toggle]")) {
            filtersOpen = !filtersOpen;
            applyFilterState();
            return;
        }
        // Desktop: collapse/expand a single filter section via its chevron header.
        const sectionBtn = e.target.closest("[data-section-toggle]");
        if (sectionBtn) {
            const id = sectionBtn.getAttribute("aria-controls");
            if (collapsedSections.has(id)) {
                collapsedSections.delete(id);
            } else {
                collapsedSections.add(id);
            }
            applyFilterState();
            return;
        }
        // "Ladda fler" keeps the current (already advanced) page number.
        if (e.target.closest("[data-load-more]")) {
            e.preventDefault();
            submit(false);
        }
    });
})();
